import React from "react";
import classNames from "classnames";
import { Item } from "./VSETHNavbar";
import { ReactRouterActionItem } from "./reactRouterHelper";
import { LinkConstructor } from "../../types";

interface Props {
  item: Item;
  NavLink: LinkConstructor;
}
export const ActionItem: React.FC<Props> = ({
  item: { icon: Icon, linkProps, onClick, href, disabled, active },
  NavLink,
}) =>
  Icon ? (
    linkProps ? (
      <NavLink
        component={ReactRouterActionItem}
        {...linkProps}
        disabled={disabled}
        exact
      >
        <Icon />
      </NavLink>
    ) : (
      <li className={classNames("nav-icon-item", { active })}>
        <a
          className={classNames("nav-icon", { disabled })}
          href={href}
          onClick={!disabled ? onClick : undefined}
        >
          <Icon />
        </a>
      </li>
    )
  ) : null;
